import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { CellShape, CellHollow } from '../shape';
import { MaybeZeroX, MaybeZeroY, MaybeZeroPadding } from '../transform';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip2d } from './utils';
var shape = {
  cell: CellShape,
  hollow: CellHollow
};
/**
 * Convert value for each channel to Cell shapes.
 * Calc the bbox of each Cell based on x, y and r.
 * This is for allowing their radius can be affected by coordinate(e.g. fisheye).
 */
export var Cell = function Cell() {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      Y = value.y;
    var x = scale.x;
    var y = scale.y;
    var P = Array.from(index, function (i) {
      var width = x.getBandWidth(x.invert(+X[i]));
      var height = y.getBandWidth(y.invert(+Y[i]));
      var x1 = +X[i];
      var y1 = +Y[i];
      var p1 = [x1, y1];
      var p2 = [x1 + width, y1];
      var p3 = [x1 + width, y1 + height];
      var p4 = [x1, y1 + height];
      return [p1, p2, p3, p4].map(function (d) {
        return coordinate.map(d);
      });
    });
    return [index, P];
  };
};
Cell.props = {
  defaultShape: 'cell',
  defaultLabelShape: 'label',
  shape: shape,
  composite: false,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true,
    scale: 'band'
  }, {
    name: 'y',
    required: true,
    scale: 'band'
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeZeroX
  }, {
    type: MaybeZeroY
  }, {
    type: MaybeZeroPadding
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip2d()))
};